import {
  Avatar,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SvgIcon,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SignModalIcon from 'src/icons/untitled-ui/duocolor/sign-modal-icon';
import { uploadSignFileAction } from 'src/redux/actions/monthlyCloseOutAction';

type Props = {
  handleClose: any;
  signData: any;
};

function generateDummyPdfBlob() {
  const dummyPdfContent = 'This is a dummy PDF content.';
  const dummyPdfBlob = new Blob([dummyPdfContent], { type: 'application/pdf' });
  return dummyPdfBlob;
}

const SignatureAlertDocument = (props: Props) => {
  const { handleClose, signData } = props;
  const dispatch = useDispatch();
  const uploadSignatureFile = useSelector((state: any) => state.uploadSignatureFileReducer);
  const [agree, setAgree] = useState(false);
  const handleSubmit = () => {
    const formData = new FormData();
    formData.append('consentForm', generateDummyPdfBlob());
    if (agree) {
      dispatch(
        uploadSignFileAction({
          data: formData,
          param: {
            startDate: signData?.range?.startDate,
            endDate: signData?.range?.endDate,
          },
        })
      );
    }
  };

  const handleChangesStatus = (e: any) => {
    setAgree(e?.target?.checked);
  };
  return (
    <>
      <DialogTitle
        alignItems={'center'}
        id="alert-dialog-title"
        mt={2}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Avatar
            sx={{
              background: '#F5F7FF',
            }}
          >
            <SvgIcon>
              <SignModalIcon />
            </SvgIcon>
          </Avatar>
          <Typography
            variant="h6"
            color="initial"
          >
            Sign Certification
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ ml: 4 }}>
        <DialogContentText id="alert-dialog-description">
          <Box sx={{ display: 'flex' }}>
            <Checkbox
              checked={agree}
              onChange={handleChangesStatus}
            />
            <Typography variant="body2">
              I certify that I have reviewed and resolved all outstanding issues associated with
              this closeout.
            </Typography>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={handleClose}
          variant="text"
        >
          <Typography variant='buttonText' color={'#384250'}>Cancel</Typography>
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!agree || uploadSignatureFile?.loading}
        >
          Submit
        </Button>
      </DialogActions>
    </>
  );
};

export default SignatureAlertDocument;
